import _ from 'lodash';
import helper from '../../preorder/api/helper';
import config from '../../preorder/configs/config';

const API_ENDPOINT = `${config.API_ENDPOINT}/externalApi-ecCommand`;
const DEFAULT_QUERY = {
  env: process.env.REACT_APP_MODE,
  language: window.language || undefined,
};

const queryPool = {};

const tick = async () => {
  if (!_.isEmpty(queryPool)) {
    const jobs = [];
    Object.keys(queryPool).forEach((key) => {
      jobs.push(queryPool[key]);
      delete queryPool[key];
    });

    try {
      const batchParameters = jobs.map((job) => job.parameters);
      const batchResult = await (helper.post({
        url: API_ENDPOINT,
        query: {
          ...DEFAULT_QUERY,
          command: 'batch',
        },
        body: batchParameters,
      }));
      jobs.forEach((job, index) => job.resolves.forEach((resolve) => resolve(batchResult[index])));
    } catch (error) {
      console.error(error);
      jobs.forEach((job) => job.rejects.forEach((reject) => reject(error)));
    }
  }
  setTimeout(tick, 500);
};
tick();

const simpleQuery = (tableName, otherProps) => new Promise((resolve, reject) => {
  const parameters = {
    ...DEFAULT_QUERY,
    tableName,
    command: 'query',
    ...(otherProps || {}),
  };
  const jobKey = JSON.stringify(parameters);
  queryPool[jobKey] = ({
    parameters,
    resolves: [..._.get(queryPool, [jobKey, 'resolve'], []), resolve],
    rejects: [..._.get(queryPool, [jobKey, 'reject'], []), reject],
  });
});

export default simpleQuery;
